import { useNotificationStore } from '@dafcoe/vue-notification'

function Toast() {
}

Toast.prototype.show = function (type, message, showIcon) {
    const { setNotification } = useNotificationStore();
    setNotification(
        {
            "message": message,
            "type": type,
            "showIcon": showIcon,
            "dismiss": {
                "manually": true,
                "automatically": true
            },
            "duration": 8000,
            "showDurationProgress": false,
            "appearance": "light"
        }
    )
}

Toast.prototype.install = function (app) {
    app.toast = this;
    app.config.globalProperties.$toast = this;
}

export function ToastPlugin() {
    return new Toast();
}